module.exports = __webpack_public_path__ + "static/img/img36.f40d52d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img36.png
// module id = LRLk
// module chunks = 1